import {
  Box,
  Typography,
  Alert,
  Link,
} from '@mui/material';

export function OnboardingInstructions() {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Як отримати API-ключ Нової пошти
      </Typography>
      <Typography variant="body2" color="text.secondary" component="ol" sx={{ pl: 2.5, m: 0 }}>
        <li>Зареєструйтесь у <Link href="https://novaposhta.ua/" target="_blank" rel="noopener">кабінеті Нової пошти</Link> як приватна особа (особистий номер телефону).</li>
        <li>Якщо ви юридична особа — підпишіть договір, вказавши робочий номер телефону бізнес-клієнта (стандартний договір на комерційну доставку, не окрема інтеграційна угода). Фізичним особам (включно з ФОП) цей крок не потрібен.</li>
        <li>У кабінеті зліва в списку оберіть «Налаштування» → «Безпека» і створіть ключ.</li>
      </Typography>
      <Alert severity="warning" sx={{ mt: 1.5 }}>
        Не плутайте з <Link href="https://novapost.com" target="_blank" rel="noopener">novapost.com</Link>{' '}
        («Nova Post») — це окремий портал під міжнародні напрямки, який вимагає формального договору
        співпраці ще до видачі ключа. Для доставки по Україні він не потрібен.
      </Alert>
    </Box>
  );
}
